/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/bmearch/"

const BMEARCH: CommunityData = {
  code: "bmearch",
  inviteCode: "bmearch",
  name: "BMERCH",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/bme-030`,
  waitlist: false,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#f2011b",
      hero: {
        desktop: `${S3_PREFIX}web-background.jpg`,
        mobile: `${S3_PREFIX}web-background-mobile.jpg`,
        style: "bg-[#C8C8C8]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[64px] h-[75px] sm:w-[94px] sm:h-[110px]",
      },
      werzLogoColor: "#000",
      title: "font-['SexPistolsRegular'] text-[28px] leading-[120%] text-[#30fd3a] uppercase",
      text: "font-['OswaldRegular'] text-[16px] leading-[120%] text-[#000000]",
      button:
        "font-['InterRegular'] text-[16px] leading-[100%] p-4 bg-[#30fd3a] text-[#000000] rounded-full cursor-pointer w-fit",
      input: {
        base: "font-['OswaldRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#ffffff] text-[#000000]",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['OswaldRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['OswaldRegular'] text-[14px] leading-[120%] text-[#000000]",
      skipButton: "font-['OswaldRegular'] text-[14px] leading-[120%] text-[#000000] cursor-pointer",
      modal: {
        container: "bg-[#d1010f] px-[40px] py-[48px]",
        title:
          "font-['SexPistolsRegular'] text-[24px] leading-[120%] text-[#30fd3a] text-center uppercase",
        text: "font-['OswaldRegular'] text-[14px] leading-[120%] text-[#000000] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#000000] bg-[#ffffff] font-['OswaldRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    global: {
      counterColor: "",
      logo: {
        src: "https://media.werz.at/community/icon/cmnhm6xcq00009k9p5zb5c6kr.jpg?uploadTime=1775562726374&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[94px] h-[110px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#f2011b",
      asideBg: "#ffffff",
      asideStyles: "",
      contentBg: "#f2011b",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['OswaldRegular']",
      primaryButton:
        "bg-[#30fd3a] border border-[#30fd3a] rounded-full px-[18px] py-[18px] !text-[#000000] font-['InterRegular'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#f2011b",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#00000040]",
      item: "font-['InterRegular'] text-[16px] text-[#f2011b] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#00000040] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#f2011b] !pb-8",
      titles:
        "text-[#30fd3a] font-['SexPistolsRegular'] text-[32px] uppercase text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#30fd3a] font-['OswaldRegular'] text-[16px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#00000040]",
        sectionTitle:
          "text-[#30fd3a] font-['SexPistolsRegular'] text-[32px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#f2011b]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['OswaldSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#30fd3a] font-['OswaldRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#00000040]",
        sectionTitle:
          "text-[#30fd3a] font-['SexPistolsRegular'] text-[32px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#f2011b]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#000000] font-['OswaldSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#30fd3a] font-['OswaldRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#30fd3a] font-['OswaldRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['OswaldRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['OswaldRegular'] text-[18px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#30fd3a] font-['SexPistolsRegular'] text-[32px] uppercase text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/bmearch/web-background-non-member.jpg",
      bgMobile: "https://media.werz.at/community-assets/bmearch/web-background-non-member.jpg",
      bgColor: "#f2011b",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#f2011b]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#ffffff]",
        name: "text-[#30fd3a] font-['OswaldSemiBold'] text-[26px] uppercase leading-[28.6px] text-center text-center mt-4 mb-1",
        location:
          "font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#ffffff] border border-[#00000040] rounded-full px-[12px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#f2011b] border border-[#ffffff] text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#f2011b] border border-[#ffffff]",
          title:
            "font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-1",
          text: "text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center text-center",
          button:
            "bg-[#ffffff] border border-[#00000040] rounded-full px-[12px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#30fd3a] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#f2011b] border border-[#ffffff]",
          duration: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#000000] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#ffffff]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#f2011b] border border-[#ffffff]",
          name: "text-[#000000] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] border border-[#ffffff] text-[#ffffff] font-['OswaldSemiBold'] text-[16px] uppercase leading-[17.6px] text-center",
          duration: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] leading-[14.4px] text-left",
          location: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#ffffff] border border-[#00000040] rounded-full px-[12px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#ffffff]",
            name: "text-[#000000] font-['OswaldSemiBold'] uppercase leading-[17.6px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#000000] font-['OswaldSemiBold'] uppercase leading-[17.6px] text-[14px] text-left",
            link: "text-[#30fd3a] font-['OswaldSemiBold'] text-[16px] uppercase leading-[17.6px] text-left",
            status:
              "text-[#000000] font-['OswaldSemiBold'] uppercase leading-[110%] text-[14px] text-left",
            button:
              "bg-[#ffffff] border border-[#00000040] rounded-full px-[12px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#f2011b] border border-[#ffffff] text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center",
        header:
          "text-[#30fd3a] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#f2011b] border border-[#ffffff]",
          name: "text-[#000000] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#ffffff]",
        },
        seeAllNews:
          "text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#f2011b] border border-[#ffffff] text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center",
        header:
          "text-[#30fd3a] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#f2011b] border border-[#ffffff]",
          coverUrl: "overflow-hidden m-2 border border-[#ffffff]",
          duration: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] leading-[14.4px] text-left",
          liveType: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#000000",
          start: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#000000] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#f2011b] border border-[#ffffff] text-[#000000] font-['OswaldRegular'] text-[18px] leading-[120%] text-center",
        header:
          "text-[#30fd3a] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#f2011b] border border-[#ffffff]",
          name: "text-[#000000] font-['OswaldSemiBold'] uppercase leading-[22px] text-[16px] text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#ffffff]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#30fd3a] font-['OswaldRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#f2011b] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#00000040]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['OswaldSemiBold'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#30fd3a] font-['OswaldRegular'] text-[16px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#30fd3a] border border-[#30fd3a] rounded-full px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['InterRegular'] !text-[16px] text-left leading-[100%]",
        questions: "text-[16px] text-left leading-[120%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#00000040]",
        header:
          "text-[#000000] font-['OswaldRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['OswaldRegular'] text-[16px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#00000040]",
        header:
          "text-[#000000] font-['OswaldRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['OswaldRegular'] text-[16px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['OswaldRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['OswaldRegular'] text-[16px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['OswaldRegular'] text-[22px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#f2011b] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border border-[#00000040] rounded-full px-[12px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#f2011b] border-b border-[#00000040] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['OswaldSemiBold'] text-[16px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#30fd3a] font-['OswaldRegular'] text-[16px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#30fd3a] font-['OswaldSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          quantity: "text-[#000000] font-['InterRegular'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#30fd3a] font-['OswaldSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff] border border-[#00000040] rounded-full px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff] border border-[#00000040] rounded-full px-[12px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default BMEARCH
